/* eslint-disable @typescript-eslint/no-explicit-any */
/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import { useMutation } from '@tanstack/react-query';

// Mantine
import { notifications } from '@mantine/notifications';

// I18n
import { useTranslation } from 'react-i18next';

// Types
import { IApiError } from '@global-types/index';

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */

export const useUploadMedia = (
	uploadMedia: (data: any) => Promise<any>
) => {
	const { t } = useTranslation();
	const {
		mutate,
		isPending: isLoading,
		isSuccess,
		data,
	} = useMutation({
		mutationFn: uploadMedia,

		onError: (error: IApiError) => {
			notifications.show({
				title: t('global.error'),
				message: t(`api.${error.type}`),
				color: 'var(--mantine-color-igluRed-9)',
			});
		},
	});

	return { mutate, isLoading, isSuccess, data };
};
